import React, { useRef, useState } from "react"
import DynamicProductCard from "../../productcards/DynamicProductCard"
import DisplayCard from "../../productcards/DisplayCard"
import TallCard from "../../productcards/TallCard"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"

import SliderButton from "../../../image/icons/slider-button.svg"
import UseWindowSize from "@components/helpers/UseWindowSize"

const ProductSwiper = ({
        products,
        cardType = 'product card',
        cardStyles = '',
        cardOptions = '',
        spaceBetween = 0,
        slidesPerView = 4,
        breakpoints = {
            // value of key is min-width property
            300: {
                slidesPerView: 1.5,
                spaceBetween: 5,
            },
            500: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            640: {
                slidesPerView: 3.5,
            },
            900: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 5,
            },
        },
        navigation = true,
        pagination = false,
        width = null,
        height = null,
        loop = false,
        onClickCard = null,
        ariaLabel=''
    }) => {
        const windowSize = UseWindowSize()
		const [isSwiping, setIsSwiping] = useState(false)

        const navigationPrevRef = useRef(null);
        const navigationNextRef = useRef(null);

        return (
            <React.Fragment>
                <div className="max-w-full mx-auto mt-6 md:mt-0">
                    {windowSize?.width !== null && (
                        <Swiper
                            aria-label={ariaLabel}
                            spaceBetween={spaceBetween}
                            slidesPerView={slidesPerView}
                            breakpoints={breakpoints}
                            modules={[Navigation]}
                            loop={loop}
                            navigation={navigation ? {
                                prevEl: navigationPrevRef.current,
                                nextEl: navigationNextRef.current,
                            } : false}
                            onBeforeInit={(swiper) => {
                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                swiper.params.navigation.nextEl = navigationNextRef.current;
                            }}
                            className="mySwiper"
							onSliderFirstMove={() => setIsSwiping(true)}
							onTouchEnd={() => {
								setTimeout(() => setIsSwiping(false), 100)
							}}
                        >
                            {
                                products && products.map((product, index) => {
                                    if (product?.title && !product.title.includes("FREE")) {
                                        return (
                                            <SwiperSlide key={`just-in-${product?.id ?? index}`}>
                                                {cardType === "display card" ? (
                                                    <DisplayCard data={product} cardStyles={cardStyles} />
                                                ) : cardType === "tall card" ? (
                                                    <TallCard data={product} cardStyles={cardStyles} onClick={onClickCard} />
                                                ) : (
                                                    <DynamicProductCard
                                                        data={product}
                                                        cardOptions={cardOptions}
                                                        style={`${cardType === "compact" ? "compact" : "classic"}`}
                                                        cardStyles={cardStyles}
                                                        width={width}
                                                        height={height}
														isSwiping={isSwiping}
                                                    />
                                                )}
                                            </SwiperSlide>
                                        );
                                    }
                                    return null;
                                })
                            }

                            <div
                                className="text-black size-4 p-2 rounded cursor-pointer z-30 absolute top-[40%] bottom-[60%]"
                                ref={navigationPrevRef}
                            >
                                <img
                                    className="absolute -top-5 w-11 h-11 max-w-11"
                                    src={SliderButton}
                                    alt="slide-left"
                                />
                            </div>

                            <div
                                className="text-black size-4 p-2 rounded cursor-pointer z-30 absolute top-[40%] bottom-[60%] right-0"
                                ref={navigationNextRef}
                            >
                                <img
                                    className="absolute -left-10 -top-5 w-11 h-11 max-w-11 transform rotate-180"
                                    src={SliderButton}
                                    alt="slide-left"
                                />
                            </div>
                        </Swiper>
                    )}
                </div>
            </React.Fragment>
        );
};

export default ProductSwiper;
